import script from "./LandingListFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingListFilters.vue?vue&type=script&setup=true&lang=ts"

import "./LandingListFilters.vue?vue&type=style&index=0&id=4cd8fac4&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd8fac4"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy,QField});
